import { createContext, useContext } from "react";

/**
 * Signals search: a single query string the active panel reads to filter its
 * rows (events, sources, pages, countries, sessions…). The query lives in
 * SignalsScreen (so it can reset on panel change) and is shared via context so
 * panels don't need prop threading.
 */
const SignalsSearchCtx = createContext("");

export const SignalsSearchProvider = SignalsSearchCtx.Provider;

/** The current query, already trimmed + lowercased. Empty string = no filter. */
export function useSignalsQuery(): string {
  return useContext(SignalsSearchCtx);
}

/**
 * True when `q` is empty (no filter) or any of the given fields contains it
 * (case-insensitive). Use to filter a row: `rows.filter((r) => matches(q, r.label))`.
 */
export function matches(q: string, ...fields: (string | number | null | undefined)[]): boolean {
  if (!q) return true;
  return fields.some((f) => f != null && String(f).toLowerCase().includes(q));
}
